import React, { useCallback, useState } from "react";
import { Menu, Row, Col, Icon } from "antd";
import { useIntl } from "react-intl";

import ClientChoice from "../clientChoice";
import ClientUserModal from "../clientUserModal";
import { success } from "../../../modules/messages";
import ClientsChoice from "../clientChoice/clientsChoice";
import { isSuperUser, signOut } from "../../../modules/session";

const { Item } = Menu;

const UserMenu = ({
  clients,
  userRole,
  onClientChange,
  defaultClientId,
  onClientIdChange,
}) => {
  const intl = useIntl();
  const [loading, setLoading] = useState();
  const logout = useCallback(() => {
    setLoading(true);
    signOut().then(() => {
      success(
        intl.formatMessage({
          id: "messages.loggedOut",
          defaultMessage: "Došlo k odhlášení!",
        })
      );
    });
  }, [intl]);

  return (
    <Menu className="dropdown-menu">
      {isSuperUser(userRole) ? (
        <Item key={8} className="user-menu-client-choice">
          <ClientChoice onClientChange={onClientChange} />
        </Item>
      ) : (
        clients &&
        clients.length > 1 && (
          <Item key={1} className="user-menu-client-choice">
            <ClientsChoice
              clients={clients}
              defaultClientId={defaultClientId}
              onClientIdChange={onClientIdChange}
            />
          </Item>
        )
      )}
      {isSuperUser(userRole) && (
        <Item key={9} className="user-menu-client-choice">
          <ClientUserModal text />
        </Item>
      )}
      <Item key={2} onClick={logout} disabled={loading}>
        <Row type="flex">
          {loading ? (
            <Col>
              <Icon spin type="loading" />
            </Col>
          ) : (
            <></>
          )}
          <Col>
            {intl.formatMessage({
              id: "messages.logOut",
              defaultMessage: "Odhlásit",
            })}
          </Col>
        </Row>
      </Item>
    </Menu>
  );
};

export default UserMenu;
